import ProductCard from "./ProductCard";
import {
  FaTools,
  FaCogs,
  FaHardHat,
  FaBoxOpen,
  FaBolt,
  FaCubes,
  FaGripLines,
  FaWrench,
} from "react-icons/fa";
import { GiDrill } from "react-icons/gi";
import { MdConveyorBelt } from "react-icons/md";
import { GiWinterGloves } from "react-icons/gi";
import { GiScrew } from "react-icons/gi";
import { GiSteampunkGoggles } from "react-icons/gi";
import { Link } from "react-router-dom";

const products = [
  {
    title: "CNC Tools & Drills",
    description: "End mills, ball nose, rotary cutters, tap sets, and more.",
    icon: <GiDrill />,
  },
  {
    title: "Bearing Solutions",
    description: "Roller, ball, needle, thrust, tapered, and sleeves.",
    icon: <FaCogs />,
  },
  {
    title: "Power Transmission Belts",
    description: "V-belts, timing belts, flat belts, ribbed belts.",
    icon: <MdConveyorBelt />,
  },
  {
    title: "Safety Equipment",
    description: "Goggles, gloves, helmets, earplugs, masks.",
    icon: <GiWinterGloves />,
  },
  {
    title: "Fasteners",
    description: "Bolts, nuts, washers in SS, MS, HT grades with plating.",
    icon: <GiScrew />,
  },
  {
    title: "Welding Consumables",
    description: "TIG/MIG torches, nozzles, filler metals, fluxes.",
    icon: <GiSteampunkGoggles />,
  },
  {
    title: "Packaging Solutions",
    description: "Tensioners, sealers, strapping tape.",
    icon: <FaBoxOpen />,
  },
  {
    title: "Rubber & Felt Products",
    description: "Rubber sheets, O-rings, felt sheets and rings.",
    icon: <FaCubes />,
  },
];

const ProductHighlights = () => {
  return (
    <section className="bg-gray-100 py-16">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
          Our Product Categories
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {products.map((item, index) => (
            <Link
              key={index}
              to={`/products#${item.title.replace(/\s+/g, "-").toLowerCase()}`}
              className="block"
            >
              <ProductCard
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductHighlights;
